import { Component, Input } from '@angular/core'
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'details-accordion-basic',
  imports: [NgbAccordionModule],
  templateUrl: './details-accordion.html',
  styleUrl: './details-accordion.scss',
})
export class DetailsAccordionComponent {
  @Input() rawFeature: string | undefined = undefined
}
